import { render, staticRenderFns } from "./IdcCustomerManagement.vue?vue&type=template&id=5e7dc51a&scoped=true&"
import script from "./IdcCustomerManagement.vue?vue&type=script&lang=js&"
export * from "./IdcCustomerManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7dc51a",
  null
  
)

export default component.exports